export function useQueryParams<T extends Record<string, string>>() {
  return Object.fromEntries(new URLSearchParams(window.location.search)) as T;
}
